"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var utils_1 = require("../../utils");
var themes_1 = require("../../themes");
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    var borderRadius = theme.spacing(2.5);
    var borderColor = 'rgb(226, 227, 229)'; // TODO: replace this with theme color
    var cellBorder = "1px solid ".concat(borderColor);
    return (0, styles_1.createStyles)({
        paper: function (_a) {
            var hasData = _a.hasData, loading = _a.loading, variant = _a.variant, height = _a.height, _b = _a.offsetHeight, offsetHeight = _b === void 0 ? '20vh' : _b, type = _a.type;
            // when fixed we set height to a fixed number, otherwise use calc with an offsetHeight
            var variantHeight = variant === 'fixed' ? height : "calc(100vh - ".concat(offsetHeight, ")");
            return {
                borderRadius: type === 'workbook' ? '8px' : borderRadius,
                // if data is empty or loading we can use auto height
                height: !hasData || loading ? 'auto' : variantHeight,
                padding: type === 'workbook' ? theme.spacing(0, 1.5) : undefined,
                width: '100%',
                maxWidth: '100%',
                overflowX: 'scroll',
            };
        },
        table: function (_a) {
            var loadMoreIndicatorSize = _a.loadMoreIndicatorSize, loading = _a.loading, minTableWidth = _a.minTableWidth;
            return ({
                height: loading ? "calc(100% - ".concat(loadMoreIndicatorSize, "px)") : '100%',
                width: '100%',
                maxWidth: '100%',
                minWidth: minTableWidth || theme.breakpoints.values.md || '960px',
            });
        },
        header: function (_a) {
            var headerHeight = _a.headerHeight, minTableWidth = _a.minTableWidth;
            return ({
                height: headerHeight,
                width: '100%',
                maxWidth: '100%',
                minWidth: minTableWidth || theme.breakpoints.values.md || '960px',
                borderBottom: cellBorder,
            });
        },
        footer: function (_a) {
            var headerHeight = _a.headerHeight, minTableWidth = _a.minTableWidth;
            return ({
                height: headerHeight,
                width: '100%',
                maxWidth: '100%',
                minWidth: minTableWidth || theme.breakpoints.values.md || '960px',
                borderTop: cellBorder,
            });
        },
        tableBody: function (_a) {
            var _b = _a.headerHeight, headerHeight = _b === void 0 ? 43 : _b, minTableWidth = _a.minTableWidth, hasFooter = _a.hasFooter;
            return ({
                height: "calc(100% - ".concat(hasFooter ? parseInt(headerHeight.toString(), 10) * 2 + 2 : headerHeight, "px)"),
                width: '100%',
                maxWidth: '100%',
                minWidth: minTableWidth || theme.breakpoints.values.md || '960px',
            });
        },
        list: function () { return ({
            height: '100%',
            width: '100%',
            overflowY: 'auto',
            overflowX: 'unset',
        }); },
        loadingMoreRow: function (_a) {
            var itemSize = _a.itemSize;
            return ({
                display: 'flex',
                height: itemSize,
                justifyContent: 'center',
                alignItems: 'center',
                maxWidth: '100%',
            });
        },
        clickableRow: function (_a) {
            var clickable = _a.clickable;
            return ({
                '&:hover': clickable
                    ? {
                        cursor: 'pointer',
                        backgroundColor: '#fffbef',
                    }
                    : {},
            });
        },
        row: function (_a) {
            var itemSize = _a.itemSize, headerHeight = _a.headerHeight, type = _a.type;
            return ({
                border: 'none',
                backgroundColor: 'transparent',
                borderBottom: type === 'workbook' ? 'none !important' : cellBorder,
                alignItems: 'center',
                '& .MuiTableCell-body': {
                    overflow: 'hidden',
                    height: itemSize,
                    display: 'flex',
                    alignItems: 'center',
                    border: type === 'workbook' ? 'none' : undefined,
                    '&:first-child': {
                        paddingLeft: type === 'workbook' ? 0 : undefined,
                    },
                },
                '& .MuiTableCell-head': {
                    height: headerHeight,
                    fontWeight: utils_1.textWeightMap.bold,
                    textTransform: 'uppercase',
                    position: 'sticky',
                    display: 'flex',
                    alignItems: 'center',
                    boxShadow: type === 'workbook' ? 'none !important' : undefined,
                    borderRight: type === 'workbook' ? 'none !important' : cellBorder,
                    fontSize: type === 'workbook' ? '10px' : utils_1.textSizeMap.text.small,
                    color: type === 'workbook' ? themes_1.materialColors.grey[400] : themes_1.materialColors.grey[500],
                    '&:first-child': {
                        paddingLeft: type === 'workbook' ? 0 : undefined,
                    },
                    '&:last-child': {
                        borderRight: 'none',
                    },
                },
            });
        },
        disabledRow: function () { return ({
            pointerEvents: 'none',
        }); },
        disabledCell: function () { return ({
            color: themes_1.materialColors.grey[200],
        }); },
        editableRow: function (_a) {
            var isEditing = _a.isEditing;
            return isEditing
                ? {
                    backgroundColor: themes_1.materialColors.yellow[50],
                }
                : {};
        },
        tableEdit: {
            backgroundColor: themes_1.materialColors.yellow[50],
        },
    });
});
exports.default = useStyles;
